export const ARRIVALREPORT_DATA_COLUMNS = [
  {
    Header: "OFP PLAN DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "MODULE",
    accessor: "DataOf",
    width : 1
  },
  {
    Header: "FACTORY IN DATE & TIME",
    accessor: "Gate_In_Date",
    width : 1
  },
  {
    Header: "CONTAINER NO",
    accessor: "Container_Number",
    width : 1
  },
  {
    Header: "SEAL NO",
    accessor: "Seal_No",
  },
  {
    Header: "LR NO",
    accessor: "LR_NO",
    width : 1
  },
  {
    Header: "VEHICLE NO",
    accessor: "Vehicle_No",
    width : 1
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
    width : 1
  },
  {
    Header: "CLEARANCE",
    accessor: "Clearence",
    width : 1
  },
  {
    Header: "DEST COUNTRY",
    accessor: "Dest_Country",
    width : 1
  },
  {
    Header: "DEST PORT",
    accessor: "Dest_Port",
    width : 1
  },
  {
    Header: "FINAL DEST",
    accessor: "final_destination",
    width : 1
  },
  {
    Header: "BOOKING NO",
    accessor: "Booking_Number",
    width : 1
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
    width : 1
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 1
  },
  {
    Header: "DRIVER NO",
    accessor: "Driver_No",
    width : 1
  },
];